import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CARDS_MAIN_PAGE_PATH } from "utils/constants/paths";

const CardsMainPage = Loadable(React.lazy(() => import("./View")));

export const CardsMainPageRoute: IRouteItem = {
  path: CARDS_MAIN_PAGE_PATH,
  element: React.createElement(CardsMainPage),
  name: "Gift Card Main Page",
};
